import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from './store/configureStore'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
// import { unregister } from './registerServiceWorker'

let store = configureStore()

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root'))
registerServiceWorker()
// unregister()



// WEBPACK FOOTER //
// ./src/index.js